import ListItem from "@mui/material/ListItem";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PublicIcon from "@mui/icons-material/Public";
import { Box, ListItemIcon, Paper, Typography, styled } from "@mui/material";
import { SearchResult } from "../../types/SearchResult";
import { CompanyStatus } from "./CompanyStatus";
import { getDateDisplay } from "../../data/utilities";
import { DELTA_ACCENT, TEXT_SECONDARY } from "../colors";
import { Link } from "react-router-dom";

const StyledLink = styled(Link)({
  textDecoration: "none",
  color: "inherit",
  display: "block",
  marginBottom: 12,
});

export const SearchResultItem = (props: { data: SearchResult }) => {
  const { data } = props;

  return (
    <StyledLink to={data.links.self}>
      <Paper
        elevation={0}
        style={{ transition: "box-shadow 0.2s" }}
        className="search-result-item"
      >
        <ListItem>
          <ListItemIcon>
            {data.company_type === "plc" ? (
              <PublicIcon style={{ color: DELTA_ACCENT }} />
            ) : (
              <BusinessCenterIcon style={{ color: DELTA_ACCENT }} />
            )}
          </ListItemIcon>
          <Box style={{ padding: 2, width: "100%" }}>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 5,
              }}
            >
              <Typography variant="subtitle1">{data.title}</Typography>
              {data.company_status !== undefined && (
                <CompanyStatus status={data.company_status} />
              )}
            </Box>

            <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
              {data.address_snippet}
            </Typography>

            {data.appointment_count !== undefined && (
              <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
                Appointments: {data.appointment_count}
              </Typography>
            )}

            {data.kind === "searchresults#company" ? (
              data.description && (
                <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
                  {data.description}
                </Typography>
              )
            ) : (
              <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
                {getDateDisplay(data.date_of_birth)}
              </Typography>
            )}
          </Box>
        </ListItem>
      </Paper>
    </StyledLink>
  );
};
